import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
  IDLE: "idle",
  ERROR: "error",
  LOADING: "loading",
});

const getTrackRecordSlice = createSlice({
  name: "TrackRecord",
  initialState: {
    data: [],
    status: STATUSES.IDLE,
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchTrackRecord.pending, (state, action) => {
        state.status = STATUSES.LOADING;
      })
      .addCase(fetchTrackRecord.fulfilled, (state, action) => {
        state.data = action.payload;
        state.status = STATUSES.IDLE;
      })
      .addCase(fetchTrackRecord.rejected, (state, action) => {
        state.status = STATUSES.ERROR;
      });
  },
});

export const { setAds, setStatus } = getTrackRecordSlice.actions;
export default getTrackRecordSlice.reducer;

export const fetchTrackRecord = createAsyncThunk(
  "/TrackRecord/fetch",
  async ({ id }) => {
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
      headers.Authorization = token;
      headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(`${baseUrl}/TrackRecord/${id}`, {
      headers
    });
    const data = res.data;
    return data.data;
  }
);
